// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'f9203ea8-6425-4ea6-bf79-08a2b3b7c7ba',
      type: 'Container',
      name: 'ribbon',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'e0eff566-f766-4856-ba3c-6aeeba65e278',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Riboon_Yellow_Half',
      parent: 'f9203ea8-6425-4ea6-bf79-08a2b3b7c7ba'
    },
    {
      id: '7d1b52c6-dcca-4308-82b8-e25f1cd3afdb',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Riboon_Yellow_Half',
      parent: 'f9203ea8-6425-4ea6-bf79-08a2b3b7c7ba'
    },
    {
      id: '1bad9303-5e1b-43cc-8c2b-58e417f84b46',
      type: 'Container',
      name: 'dioramaProgressBar',
      className: '',
      x: 0,
      y: 65,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'f9203ea8-6425-4ea6-bf79-08a2b3b7c7ba'
    },
    {
      id: '311a5cbe-4334-4538-b7a5-f77311ea4171',
      type: 'NineSlicePlane',
      name: 'dioramaProgressBarFrame',
      className: '',
      x: -160,
      y: -15,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 320,
      height: 62,
      leftWidth: 28,
      topHeight: 28,
      rightWidth: 28,
      bottomHeight: 28,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Background_3Slice_28x28',
      parent: '1bad9303-5e1b-43cc-8c2b-58e417f84b46'
    },
    {
      id: 'cd9fd1af-3096-4ef7-9ed0-6b08bfda7d0f',
      type: 'NineSlicePlane',
      name: 'dioramaProgressBarBack',
      className: '',
      x: -150,
      y: -5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 300,
      height: 40,
      leftWidth: 21,
      topHeight: 21,
      rightWidth: 21,
      bottomHeight: 21,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Empty_3Slice_21x21',
      parent: '1bad9303-5e1b-43cc-8c2b-58e417f84b46'
    },
    {
      id: '73712a36-509a-4ee0-83f3-2300dc728b8a',
      type: 'NineSlicePlane',
      name: 'dioramaProgressBarFill',
      className: '',
      x: -148,
      y: -2,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 296,
      height: 34,
      leftWidth: 18,
      topHeight: 18,
      rightWidth: 18,
      bottomHeight: 18,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Full_3Slice_18x18',
      parent: '1bad9303-5e1b-43cc-8c2b-58e417f84b46'
    },
    {
      id: '573b9294-f286-4ba4-be19-bf01b7444ed3',
      type: 'Text',
      name: 'countText',
      className: '',
      x: 0,
      y: 16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10/10',
      localize: false,
      maxWidth: 216,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#8D2400',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1bad9303-5e1b-43cc-8c2b-58e417f84b46'
    },
    {
      id: '19899109-cc7b-4c66-8777-65ecaf3d6018',
      type: 'Container',
      name: 'chestSlot',
      className: '',
      x: 109,
      y: 6,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1bad9303-5e1b-43cc-8c2b-58e417f84b46'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'opened'
  ],
  animations: [
    {
      id: '918c76fa-1fd9-4e8f-8dae-f67ebfafc7a7',
      name: 'Chest_Open',
      playingSpeed: 1,
      totalDuration: 800,
      blocks: [
        {
          id: '944d0256-fa15-4544-b6b9-35a69ac64e94',
          type: 'Tween',
          name: 'squeeze1',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a612224f-cf94-4d97-af34-ece5becdb3fb',
          type: 'Tween',
          name: 'squeeze2',
          duration: 200,
          track: 0,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8c1e185c-0d03-4573-bbe8-295cf3c227ba',
          type: 'Tween',
          name: 'rotation1',
          duration: 300,
          track: 2,
          target: {
            angle: 10
          },
          startAt: 150,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f9bb8cc1-cf30-4c37-9a16-d21b6c508c46',
          type: 'Tween',
          name: 'translation1',
          duration: 300,
          track: 1,
          target: {
            y: -120
          },
          startAt: 150,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '80d0e49c-1884-456f-a66d-ace5068309ff',
          type: 'Tween',
          name: 'squeeze3',
          duration: 150,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 300,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'af743554-6306-4c26-b57b-a3d983f4f2fa',
          type: 'Setter',
          name: 'ANIMEVENT_spawnGifts',
          track: 4,
          target: {},
          startAt: 450,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '4970f281-0011-4772-a043-74a94cb50ec4',
          type: 'Setter',
          name: 'ANIMEVENT_changeTexture',
          track: 3,
          target: {},
          startAt: 450,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '58cadfc2-20bd-4ec3-b547-f24b5d12d538',
          type: 'Tween',
          name: 'squeeze4',
          duration: 150,
          track: 0,
          target: {
            scale: {
              x: 0.9,
              y: 1.1
            }
          },
          startAt: 450,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b0f24312-ec12-4eef-b605-a4609ee6ef59',
          type: 'Tween',
          name: 'rotation2',
          duration: 150,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 470,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6cb9f9ac-b0ed-47b4-a7b0-a98f07315016',
          type: 'Tween',
          name: 'translation2',
          duration: 170,
          track: 1,
          target: {
            y: 0
          },
          startAt: 500,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7bf7ef73-17ad-4b76-b22a-45b21d67fbdd',
          type: 'Setter',
          name: 'FXPART_Race_Event_Particle_Behind_Chest_After_Opening',
          track: 5,
          target: {},
          startAt: 556,
          sourceName: 'particleSpawnPoint',
          disabled: false
        },
        {
          id: 'c8fedef1-d77f-4e90-83b9-f79f4c278765',
          type: 'Tween',
          name: 'squeeze5',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1.1,
              y: 0.9
            }
          },
          startAt: 600,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '47e3c703-afe8-4c2d-bcf4-53cc3bc58998',
          type: 'Tween',
          name: 'squeeze6',
          duration: 100,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 700,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class DioramaHeaderLayout {
  static raw = raw;
  root!: Container;
  ribbon!: Container;
  dioramaProgressBar!: Container;
  dioramaProgressBarFrame!: NineSlicePlane;
  dioramaProgressBarBack!: NineSlicePlane;
  dioramaProgressBarFill!: NineSlicePlane;
  countText!: Text;
  chestSlot!: Container;
  StateName!: 'opened';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Chest_Open {
  Layout: {
    root: object;
    particleSpawnPoint: object;
  };

  BlockTypeByName: {
    squeeze1: object;
    squeeze2: object;
    rotation1: object;
    translation1: object;
    squeeze3: object;
    ANIMEVENT_spawnGifts: object;
    ANIMEVENT_changeTexture: object;
    squeeze4: object;
    rotation2: object;
    translation2: object;
    FXPART_Race_Event_Particle_Behind_Chest_After_Opening: object;
    squeeze5: object;
    squeeze6: object;
  };

  flowData = raw.animations[0];
}
